import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Format } from "../index";
import styles from "./style.module.scss";

interface SupportedFormatsProps {
  formatList: Format[];
  tooltipText?: string | JSX.Element;
}

export default function SupportedFormats({
  formatList,
  tooltipText,
}: SupportedFormatsProps) {
  return (
    <div className={styles.supportedFormats}>
      <div className={styles.formatsHeader}>
        <div>Supported Folder Structure</div>
        {tooltipText && (
          <Tooltip title={tooltipText} placement="right">
            <InfoCircleOutlined className={styles.infoIcon} />
          </Tooltip>
        )}
      </div>

      <div className={styles.formatsContent}>
        {formatList.map((format, index) => (
          <div key={index} className={styles.formatRow}>
            <div className={styles.formatRowTitle}>{format.type}</div>
            <div className={styles.formatRowValue}>
              {format.formats.join(", ")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
